
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPositionById } from '@/services/positionService';
import { TechniqueDetails } from '@/components/technique/TechniqueDetails';
import { useSavedTechniques } from '@/hooks/useSavedTechniques';
import { useOfflineTechniqueBySlug } from '@/contexts/offline';
import { Position } from '@/types/technique';

const TechniqueDetail = () => {
  const { slug } = useParams();
  const [_position, _setPosition] = useState<Position | null>(null);

  // Use offline-aware technique fetching by slug
  const {
    data: technique,
    loading,
    error
  } = useOfflineTechniqueBySlug(slug || '');

  // Use saved techniques hook for save functionality
  const techniques = technique ? [technique] : [];
  const { savedTechniques, handleSaveTechnique } = useSavedTechniques(techniques);

  useEffect(() => {
    const fetchPositionData = async () => {
      if (technique?.position_id) {
        try {
          const positionData = await getPositionById(technique.position_id);
          _setPosition(positionData);
        } catch (err) {
          console.error('Failed to fetch position data:', err);
        }
      }
    };

    fetchPositionData();
  }, [technique?.position_id]);

  if (!slug) {
    return <div className="container mx-auto px-4 py-8 text-center">
      <p className="text-destructive">No technique slug provided</p>
    </div>;
  }

  if (loading) {
    return <div className="container mx-auto px-4 py-8">Loading technique...</div>;
  }

  if (error) {
    return <div className="container mx-auto px-4 py-8 text-center">
      <p className="text-destructive">{error}</p>
    </div>;
  }

  if (!technique) {
    return <div className="container mx-auto px-4 py-8 text-center">
      <p>Technique not found</p>
    </div>;
  }

  const isSaved = savedTechniques.includes(technique.id);
  const onToggleSave = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleSaveTechnique(technique);
  };

  return (
    <div className="container mx-auto px-4 py-8 space-y-6">
      <TechniqueDetails 
        technique={technique} 
        isSaved={isSaved}
        onToggleSave={onToggleSave}
        isLoading={loading}
      />
    </div>
  );
};

export default TechniqueDetail;
